"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Shared = require("./Shared.styled");
var _jsxRuntime = require("react/jsx-runtime");
var Item = function Item(_ref) {
  var children = _ref.children,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shared.StyledItem, {
    "data-active": isActive,
    children: /*#__PURE__*/_react.default.cloneElement(children, {
      level: level,
      isActive: isActive
    })
  });
};
var _default = exports.default = Item;